query GetUniqueIssues(
	$offset: Int!
	$limit: Int!
	$sort: uniqueness_issuesSort
	$daysFilter: ConditionInt
	$severityFilter: ConditionString
	$issueTypeFilter: ConditionString
	$environmentFilter: ConditionString
	$businessUnitFilter: ConditionString
	$textSearch: uniqueness_issuesSearchInsensitive
) {
	uniqueness_issues(
		offset: $offset
		limit: $limit
		sort: $sort
		last_seen_last_n_days: $daysFilter
		severity_eq: $severityFilter
		issue_type_eq: $issueTypeFilter
		environment_eq: $environmentFilter
		business_unit_eq: $businessUnitFilter
		text_contains: $textSearch
	) {
		uniqueness_id
		last_issue_id
		run_id
		issue_type
		severity
		page_title
		page_url
		product_name
		first_seen
		last_seen
		business_unit
		environment
	}
	total: uniqueness_issues(
		last_seen_last_n_days: $daysFilter
		severity_eq: $severityFilter
		issue_type_eq: $issueTypeFilter
		environment_eq: $environmentFilter
		business_unit_eq: $businessUnitFilter
		text_contains: $textSearch
	) {
		uniqueness_id_count
	}
	unfilteredTotal: uniqueness_issues {
		uniqueness_id_count
	}
}
